import { Component, forwardRef, Inject, Input } from '@angular/core';
import { BlockUI, NgBlockUI }                   from 'ng-block-ui';
import { NgbActiveModal }                       from '@ng-bootstrap/ng-bootstrap';
import { NgForm }                               from '@angular/forms';

import { CodeTypeModel }      from '../core/models/code-type';
import { MessagesService }    from '../messages/messages.service';
import { PriceMatrixModel }   from './typings/price-matrix.matrix';
import { PriceMatrixService } from './price-matrix.service';

@Component({
  selector   : 'wor-price-matrix-add',
  template: require('./price-matrix.add.component.html')
})
export class PriceMatrixAddComponent {
  @BlockUI('priceMatrixAddBlock') block: NgBlockUI;

  @Input() types: Array<CodeTypeModel>;

  matrix = {} as PriceMatrixModel;

  constructor (
    public  activeModal       : NgbActiveModal,
    private messagesService   : MessagesService,
    @Inject(forwardRef(() => PriceMatrixService))
    private priceMatrixService: PriceMatrixService,
  ) {}

  save ( form : NgForm ) : void {
    this.block.start();

    this.priceMatrixService.create(this.matrix)
    .then(( matrix : PriceMatrixModel ) => this.activeModal.close(matrix))
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }
}
